import React from 'react';
import Icon from '../../../../muiComponents/Icon';
import { supplierTaxTypesIcons } from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import useTranslate from '../../../../customHooks/useTranslate';

interface ISupplierTaxTypeIconProps {
    entityKey: string;
    text: string;
}

const SupplierTaxTypeIcon = ({
    entityKey,
    text,
}: ISupplierTaxTypeIconProps) => {
    const translate = useTranslate();
    const supplierTaxTypeIcon =
        supplierTaxTypesIcons[entityKey as keyof typeof supplierTaxTypesIcons];

    return (
        <Tooltip title={`${translate('type')}: ${text || ''}`}>
            <span className='flex gap-5 flex-align-center'>
                <Icon iconName={supplierTaxTypeIcon} />
            </span>
        </Tooltip>
    );
};

export default SupplierTaxTypeIcon;
